import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { alpha, Box, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { Button } from '@mui/material';
import { Calendar, Calendar2, Fatrows } from 'iconsax-react';
// import { MonthView } from "./MonthView";
import { DayView } from './DayView';
import { WeekView } from './WeekView';
import { MonthView } from './MonthView';
import { CalendarDialog } from './CalendarDialog';
import SponsorshipCard from '../Sponsorship-Details/DetailsTab/components/SponsorshipCard';
import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@mui/icons-material';
import ButtonTabs from '@ui/components/ButtonGroup/ButtonTabItem';
import { Icon } from '@iconify/react';
import { StyledMenu } from '@ui/components/common/Menu';
import YearView from './YearView';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Sample data for demonstration
const today = new Date();
const sampleData = [
    {
        id: '1',
        title: 'Kickoff Meeting',
        start: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        end: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        type: 'event',
        status: 'approved'
    },
    {
        id: '2',
        title: 'Partner Review',
        start: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),
        end: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),
        type: 'event',
        status: 'pending'
    },
    {
        id: '3',
        title: 'Event Planning',
        start: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2),
        end: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2),
        type: 'event',
        status: 'approved'
    },
    {
        id: '4',
        title: 'Game Planning',
        start: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2),
        end: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2),
        type: 'event',
        status: 'approved'
    },
    {
        id: '5',
        title: 'Sprint Planning',
        start: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2),
        end: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2),
        type: 'event',
        status: 'approved'
    },
    {
        id: '6',
        title: 'Tactics Planning',
        start: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2),
        end: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2),
        type: 'event',
        status: 'approved',
        logo: 'https://upload.wikimedia.org/wikipedia/en/5/53/Arsenal_FC.svg',
        teamName: 'Arsenal FC'
    }
];
export const ScheduleCalendar = ({ items, onDateChange, onViewChange }) => {
    const theme = useTheme();
    const location = useLocation();
    const { t } = useTranslation();
    const isSponsorshipDetailsCalendarTab = location.pathname.includes('sponsorship-details');
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [currentDate, setCurrentDate] = useState(new Date());
    const [view, setView] = useState('Month');
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const isMenuOpen = Boolean(menuAnchorEl);
    const handleDateChange = (newDate) => {
        setCurrentDate(newDate);
        if (onDateChange) {
            onDateChange(newDate);
        }
    };
    // Notify parent when view changes
    useEffect(() => {
        if (onViewChange) {
            onViewChange(view);
        }
    }, [view, onViewChange]);
    const goToPrev = () => {
        setCurrentDate((prev) => {
            let newDate;
            if (view === 'Year') {
                newDate = new Date(prev.getFullYear() - 1, prev.getMonth(), prev.getDate());
            }
            else if (view === 'Month') {
                newDate = new Date(prev.getFullYear(), prev.getMonth() - 1, 1);
            }
            else if (view === 'Week') {
                newDate = new Date(prev.getFullYear(), prev.getMonth(), prev.getDate() - 7);
            }
            else {
                // Day
                newDate = new Date(prev.getFullYear(), prev.getMonth(), prev.getDate() - 1);
            }
            handleDateChange(newDate);
            return newDate;
        });
    };
    const goToNext = () => {
        setCurrentDate((prev) => {
            let newDate;
            if (view === 'Year') {
                newDate = new Date(prev.getFullYear() + 1, prev.getMonth(), prev.getDate());
            }
            else if (view === 'Month') {
                newDate = new Date(prev.getFullYear(), prev.getMonth() + 1, 1);
            }
            else if (view === 'Week') {
                newDate = new Date(prev.getFullYear(), prev.getMonth(), prev.getDate() + 7);
            }
            else {
                // Day
                newDate = new Date(prev.getFullYear(), prev.getMonth(), prev.getDate() + 1);
            }
            handleDateChange(newDate);
            return newDate;
        });
    };
    const goToToday = () => {
        const today = new Date();
        handleDateChange(today);
        setCurrentDate(today);
    };
    // Use provided items or fall back to sampleData
    const data = items ?? sampleData;
    const handleItemClick = (item) => {
        // Set window globals that CalendarDialog relies on to display events
        window.calendarDialogAllItems = data;
        window.calendarDialogSelectedDate = item.start;
        setSelectedItem(item);
        setModalOpen(true);
    };
    // Get the icon for the currently selected view
    const getSelectedViewIcon = () => {
        switch (view) {
            case 'Month':
                return _jsx(Calendar2, { variant: 'Outline' });
            case 'Day':
                return _jsx(Icon, { icon: 'ci:columns' });
            case 'Week':
                return _jsx(Calendar, { variant: 'Outline' });
            case 'Year':
                return _jsx(Fatrows, { variant: 'Outline' });
            default:
                return _jsx(Calendar2, { variant: 'Outline' });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(SponsorshipCard, { disableBorders: true, disableShadow: true, variant: 'grey', haveHeader: true, headerVericalAlign: isSmallScreen ? true : false, heading: `${currentDate.toLocaleString('default', { month: 'long' })} ${currentDate.getFullYear()}`, customButton: _jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', gap: '12px', padding: 1, borderRadius: '14px', border: `1px solid ${theme.palette.primary.darker}`, height: '48px', children: [_jsx(IconButton, { size: isSmallScreen ? 'small' : 'medium', sx: { border: 'none' }, onClick: goToPrev, children: _jsx(ArrowBackIosOutlined, { sx: { color: theme.palette.primary.darker } }) }), _jsx(IconButton, { size: isSmallScreen ? 'small' : 'medium', sx: { border: 'none' }, onClick: goToNext, children: _jsx(ArrowForwardIosOutlined, { sx: { color: theme.palette.primary.darker } }) })] }), isSmallScreen ? (_jsxs(_Fragment, { children: [_jsx(IconButton, { size: 'small', sx: {
                                        borderColor: theme.palette.primary.darker,
                                        background: alpha(theme.palette.primary.main, 0.08),
                                        color: theme.palette.primary.darker
                                    }, onClick: (event) => setMenuAnchorEl(event.currentTarget), children: getSelectedViewIcon() }), _jsx(StyledMenu, { anchorEl: menuAnchorEl, open: isMenuOpen, onClose: () => setMenuAnchorEl(null), actions: [
                                        {
                                            text: 'Month',
                                            icon: _jsx(Calendar2, { variant: 'Outline' }),
                                            to: () => {
                                                setView('Month');
                                                setMenuAnchorEl(null);
                                            }
                                        },
                                        {
                                            text: 'Day',
                                            icon: _jsx(Icon, { icon: 'ci:columns' }),
                                            to: () => {
                                                setView('Day');
                                                setMenuAnchorEl(null);
                                            }
                                        },
                                        {
                                            text: 'Week',
                                            icon: _jsx(Calendar, { variant: 'Outline' }),
                                            to: () => {
                                                setView('Week');
                                                setMenuAnchorEl(null);
                                            }
                                        },
                                        {
                                            text: 'Year',
                                            icon: _jsx(Fatrows, { variant: 'Outline' }),
                                            to: () => {
                                                setView('Year');
                                                setMenuAnchorEl(null);
                                            }
                                        }
                                    ], selectedItem: view })] })) : (_jsx(ButtonTabs, { useIconButton: true, tabs: [
                                { label: 'Month', value: 0, icon: _jsx(Calendar2, { variant: 'Outline' }) },
                                { label: 'Day', value: 1, icon: _jsx(Icon, { icon: 'ci:columns' }) },
                                { label: 'Week', value: 2, icon: _jsx(Calendar, { variant: 'Outline' }) },
                                { label: 'Year', value: 3, icon: _jsx(Fatrows, { variant: 'Outline' }) }
                            ], activeTab: view === 'Month' ? 0 : view === 'Day' ? 1 : view === 'Week' ? 2 : 3, onTabChange: (val) => {
                                const newView = val === 0 ? 'Month' : val === 1 ? 'Day' : val === 2 ? 'Week' : 'Year';
                                setView(newView);
                            }, size: 'small', activeColor: 'primary', variant: 'outlined', showIcons: false })), _jsx(Button, { variant: 'outlined', sx: {
                                borderColor: '#575756',
                                color: '#000000'
                            }, size: isSmallScreen ? 'small' : 'large', onClick: goToToday, children: t('common.today') })] }), children: [view === 'Month' && (_jsx(MonthView, { isSponsorshipDetailsCalendarTab: isSponsorshipDetailsCalendarTab ? true : false, year: currentDate.getFullYear(), month: currentDate.getMonth(), today: new Date(), items: data, handleOpenModal: handleItemClick })), view === 'Day' && (_jsx(DayView, { isSponsorshipDetailsCalendarTab: isSponsorshipDetailsCalendarTab ? true : false, date: currentDate, items: data || [], handleOpenModal: handleItemClick })), view === 'Week' && (_jsx(WeekView, { isSponsorshipDetailsCalendarTab: isSponsorshipDetailsCalendarTab ? true : false, date: currentDate, items: data || [], handleOpenModal: handleItemClick })), view === 'Year' && (_jsx(YearView, { isSponsorshipDetailsCalendarTab: isSponsorshipDetailsCalendarTab ? true : false, year: currentDate.getFullYear(), selectedDate: currentDate, items: data || [], handleOpenModal: handleItemClick, onDateClick: (date) => handleDateChange(date) }))] }), _jsx(CalendarDialog, { open: modalOpen, item: selectedItem, onClose: () => setModalOpen(false) })] }));
};
